import React, { useEffect, useState } from 'react'
import Navbar from '../componenst/Navbar'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Badge } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Modaljadwalterbokinguser from '../componenst/Jadwalranktam/Modaljadwalterbokinguser';
import Modalfullbookingrankteam from '../componenst/Jadwalranktam/Modalfullbookingrankteam';

export default function Jadwalrankteam() {
    const urlapi = process.env.REACT_APP_BASE_URL;
    const [gamerankteam, setGamerankteam] = useState([])
    const [select, setSelect] = useState(0);
    const [modalshow, setModalshow] = useState(false)
    const [norank, setNorank] = useState(0)
    const [datarank, setDatarank] = useState([])
    const [team, setTeam] = useState([]);
    const [bookinguser, setBookinguser] = useState('')
    const [databookinguser, setDatabookinguser] = useState([])
    const [fullbooking, setFullbooking] = useState(false)
    const [jmlrank, setJmlrank] = useState(0);

    const getGame = async () => {
        try {
            const response = await axios.get(urlapi + "Fungamerankteam");
            console.log(response.data);
            setGamerankteam(response.data);
        } catch (error) {
            setGamerankteam("");
        }
    };

    const handlejadwal = (id, no, data) => {
        setSelect(id)
        setModalshow(true)
        setNorank(no + 1)
        setDatarank(data);
        // console.log(data.kode_main);
        getBookingrankteam(data.kode_main)

    }
    const geteam = async () => {
        try {
            const response = await axios.get(
                urlapi + "Datateam?id_user=" + localStorage.getItem("id")
            );
            setTeam(response.data);
        } catch (error) { }
    };

    const getBookingrankteam = async (kode) => {
        try {
            const response = await axios.get(urlapi + 'Bookingmainrankteam?kode=' + kode + "&&iduser=" + localStorage.getItem('id'));
            if (response.data.status == 'full') {
                setFullbooking(true);
                setBookinguser(false)
            } else {
                setBookinguser(true)
                setFullbooking(false)
                setDatabookinguser(response.data);
            }

            console.log(response.data);

        } catch (error) {
            setBookinguser(false)
            setFullbooking(false)
        }
    }

    const getjmlrankteam = async () => {
        try {
            const response = await axios.get(urlapi + "Jmlrankteam");
            setJmlrank(response.data.jml)
        } catch (error) {

        }
    }


    useEffect(() => {
        getGame();
        geteam();
        getjmlrankteam();
    }, [])
    return (
        <div>
            <Navbar judul="Jadwal rank team" aicon='true' />
            <div className={gamerankteam == false ? 'card' : 'd-none'} style={{ height: '100vh' }}>
                <div className='card-body'>
                    <br />
                    <br />
                    <br />
                    <br />
                    <center>
                        <div className='mt-5'>
                            <img src="./img/jam.png" className="img-fluid" alt="..." style={{ height: '300px' }} />
                            <h5 className='fw-bold' style={{ color: '#2b2e5a' }}>Hello {localStorage.getItem('nama')}</h5>
                            <div className='text-secondary'>Mohon maaf jadwal rank team untuk saat ini belum tersedia. Cobalah dilain waktu</div>
                            <div className='mt-1'>
                                <Link to='/teamrankteam' className='btn btn-primary rounded-pill' id='btnmmsc' style={{ textDecoration: 'none' }}> <i className='fas fa-angle-left'></i> Kembali</Link>
                            </div>
                        </div>
                    </center>
                </div>
            </div>

            <div className={gamerankteam == false ? 'd-none' : 'card'} style={jmlrank > 5 ? {} : { height: '100vh' }}>
                <div className='card-body'>
                    <div className='card bg-info mt-5 border-0'>
                        <div className='card-body'>
                            <h5 className='fw-bold text-white'>Hello {localStorage.getItem('nama')}</h5>
                            <div className='text-white'>Jadwal rank team sudah dibuka, daftar sekarang juga</div>
                        </div>
                    </div>

                    <div className='mt-3'>
                        <div className='d-flex justify-content-between text-secondary'>
                            <div><i className='fas                                                                                                                  fa-calendar-day'></i> Jadwal rank team</div>
                        </div>

                        <div className='mt-2'>
                            <div className='row'>
                                {gamerankteam.map((data, index) => {
                                    return (
                                        <div className='col-sm-6 col-6 mt-2' key={index} onClick={() => handlejadwal(data.id, index, gamerankteam[index])}>
                                            <div className={select == data.id ? 'card shadow border-primary' : 'card shadow'} id="bglistwinrate">
                                                <div className='card-body'>
                                                    <label class="fw-bold" style={{ color: "#2b2e5a" }}>
                                                        Rank team {index + 1}
                                                    </label>
                                                    <br />

                                                    <small style={{ color: "#2b2e5a" }}>
                                                        {data.lapangan}
                                                        <br />
                                                        <Badge bg="primary"> Rp. {data.harga}</Badge>

                                                    </small>
                                                    <hr />
                                                    <div
                                                        class="d-flex justify-content-between fw-bold"
                                                        style={{ fontSize: "7px" }}
                                                    >
                                                        <div>
                                                            <small>Tanggal main</small>
                                                            <br />
                                                            {data.tgl_main}
                                                        </div>

                                                        <div style={{ textAlign: "right" }}>
                                                            <small>Jam main</small>
                                                            <br />
                                                            {data.jam_main} WIB
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>

                </div>

                <Modal
                    show={modalshow}
                    onHide={() => setModalshow(false)}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body>
                        {bookinguser == true ? <>
                            <Modaljadwalterbokinguser data={databookinguser} />
                            <div className='mt-3'>
                                <button className='btn btn-secondary w-100' onClick={() => setModalshow(false)}><i className='fas fa-xmark'></i> Cancel</button>
                            </div>
                        </> :
                            fullbooking == true ? <><Modalfullbookingrankteam />  <div className='mt-3'>
                                <button className='btn btn-secondary w-100' onClick={() => setModalshow(false)}><i className='fas fa-xmark'></i> Cancel</button>
                            </div></> :
                                <>
                                    <div className='text-center my-5'>
                                        <img src="./img/modalrankteam.png" className="img-fluid" style={{ height: '150px' }}></img>
                                        <div className='text-secondary'>Berikut adalah harga untuk bergabung rank team {norank}</div>
                                        <h5 className='fw-bold'>Rp. {datarank.harga}</h5>
                                    </div>
                                    <div className="row">
                                        <div className='col-sm-6 col-6'>
                                            <button className='btn btn-secondary w-100' onClick={() => setModalshow(false)}><i className='fas fa-xmark'></i> Cancel</button>
                                        </div>

                                        <div className='col-sm-6 col-6'>
                                            <Link to={'/checkoutrankteam/' + datarank.kode_main + '/' + team.kode + '/1'} className='btn btn-primary w-100' id='btnmmsc'> <i className='fas fa-money-bill'></i> Bayar</Link>
                                        </div>

                                    </div>
                                </>
                        }

                    </Modal.Body>
                </Modal>


            </div>
        </div >
    )
}
